import { SuiteCRMActionTypes } from './types/actions'
import { initState } from './types/reducer'
import {
  INTEGRATE_SUITE_CRM,
  INTEGRATE_SUITE_CRM_SUCCESS,
  INTEGRATE_SUITE_CRM_ERROR,
} from './constants'

export const initialState: initState = {
  isLoading: false,
  error: {
    message: '',
  },
  data: {
    suiteCRM: {
      username: '',
      password: '',
      url: '',
    },
  },
}

const reducer = (
  state: initState = initialState,
  action: SuiteCRMActionTypes,
): initState => {
  switch (action.type) {
    case INTEGRATE_SUITE_CRM:
      return { ...state, isLoading: true }
    case INTEGRATE_SUITE_CRM_SUCCESS:
      return {
        ...state,
        isLoading: false,
      }
    case INTEGRATE_SUITE_CRM_ERROR:
      return {
        ...state,
        isLoading: false,
        error: {
          message: action.payload,
        },
      }

    default:
      return state
  }
}

export default reducer
